var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const GET_SET_CUSTOMERS = 'api/customer';
const GET_SET_CUSTOMERS_APP = 'api/v2/washdayapp/customers';
export const deleteByIdCustomersApp = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_CUSTOMERS_APP}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteByIdCustomersApp:', error);
            throw error;
        }
    });
};
export const deleteById = function (id) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const config = {
                headers: { Authorization: `Bearer ${this.apiToken}` }
            };
            return yield this.axiosInstance.delete(`${GET_SET_CUSTOMERS}/${id}`, config);
        }
        catch (error) {
            console.error('Error fetching deleteById:', error);
            throw error;
        }
    });
};
